<template>
  <div class="h-100">
    <transition mode="out-in" appear>
      <router-view></router-view>
    </transition>
    <notifications />
    <no-internet-modal />
  </div>
</template>

<script>
import NoInternetModal from './components/NoInternetModal.vue';
export default {
  data() {
    return {
      faviconUrl: 'https://s3-medex-partners.s3.amazonaws.com/' + location.hostname.replace('www.', '') + '.ico',
      title: '',
    };
  },
  components: {
    NoInternetModal,
  },
  methods: {
    setFavicon() {
      var head = document.querySelector('head');
      var link = document.createElement('link');
      link.setAttribute('rel', 'shortcut icon');
      link.setAttribute('href', this.faviconUrl);
      head.appendChild(link);
    },
    setTitle() {
      var url = location.hostname
        .replace('dev-', '')
        .replace('www.', '')
        .replace('uat-', '')
        .replace('stg-', '')
        .replace('admin-', '')
        .replace('admin.', '');
      let regex = /(.+?)[.-](.+?)[.](.+?)/;

      let match;
      if (url === 'localhost') {
        document.title = 'Telemedicina';
        this.title = 'Telemedicina';
      } else {
        match = url.match(regex);
        let formattedUrl = match[1].replace(/-/g, ' ') + ' - ' + match[2].replace(/-/g, ' ');
        formattedUrl = formattedUrl.replace(
          /\w\S*/g,
          (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        );
        document.title = formattedUrl;
        this.title = formattedUrl;
      }
    },
  },
  mounted() {
    // this.setTitle();
    // this.setFavicon();
  },
};
</script>

<style lang="scss">
@import './assets/scss/variables';
$primary: $btn-pri-bg;
$success: $btn-pri-bg;
$info: #f5f6ff;
$tertiary: $bg-login;
$gray-600: $txt;
$gray-700: $ipt-txt;
$gray-900: $sub-title;

$theme-colors: (
  'primary': $btn-pri-bg,
  'secundary': $btn-sec-bg,
  'tertiary': $bg-login,
  'quartiary': $btn-pri-bg,
  'gray-600': $txt,
  'gray-700': $ipt-txt,
  'gray-900': $sub-title,
);

// Import Bootstrap and BootstrapVue source SCSS files
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

@import './assets/scss/main.scss';
</style>
